<template>
  <div class="league-container">
    <div class="action-header">
      <el-button type="primary" @click="handleAdd">添加联盟</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="fullName">
        <template slot="header" slot-scope="scope">
          <div>联盟全称</div>
          <el-input
            v-model="search.fullName"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="name">
        <template slot="header" slot-scope="scope">
          <div>联盟简称</div>
          <el-input
            v-model="search.name"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"/>
    </div>

    <!-- create/edit modal start -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :title="modalTitle" center>
      <el-form ref="dialogForm" :model="dialogForm" :rules="rules" class="modal" label-width="100px">
        <el-form-item label="上传LOGO">
          <el-upload
            :accept="accept"
            :action="qiniuUp"
            :data="dataObj"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="beforeAvatarUpload"
            class="avatar-uploader">
            <img v-if="dialogForm.logo" :src="dialogForm.logo | ImageFormats" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
        </el-form-item>
        <el-form-item label="联盟全称" prop="fullName">
          <el-input v-model="dialogForm.fullName"/>
        </el-form-item>
        <el-form-item label="联盟简称" prop="name">
          <el-input v-model="dialogForm.name"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('dialogForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- create/edit modal start -->
  </div>
</template>

<script>
import { getQiniuUploadToken } from '@/api/site'
import { getLeagueList, getLeagueListPagination, addLeague, getLeague, deleteLeague, updateLeague } from '@/api/stats'
import { varConfig, ImageFormat, showMessage, ConstConfig } from '@/utils'

const defaultForm = {
  logo: '',
  fullName: '',
  name: ''
}

export default {
  name: 'leagueList',
  data() {
    return {
      search: {},
      list: [],
      dialogForm: {},
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
      isEditMode: false,
      modalTitle: '',
      dialogVisible: false,
      formLabelWidth: '100px',
      qiniuUp: varConfig.qiniuUp,
      dataObj: { token: '' },
      accept: ConstConfig.accept,
      rules: {
        fullName: [
          { required: true, message: '请输入联盟全称', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入联盟简称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getList()
    this.getQiniuToken()
  },
  computed: {},
  watch: {},
  methods: {
    handleAdd() {
      this.dialogVisible = true
      this.isEditMode = false
      this.modalTitle = '添加联盟信息'
      this.dialogForm = Object.assign({}, defaultForm)
    },
    handleEdit(index, row) {
      this.getLeagueById(this.list[index].id)
      this.dialogVisible = true
      this.isEditMode = true
      this.modalTitle = '编辑联盟信息'
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该联盟, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteLeague(this.list[index].id)
      }).catch(() => {
      })
    },
    // image upload
    beforeAvatarUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        showMessage('error', '上传LOGO图片大小不能超过 10MB!')
      }
      return isLt10M
    },
    handleUploadSuccess(res, file) {
      this.dialogForm.logo = res.hash
    },
    handleUploadError(res, file) {
      showMessage('error', '上传图片失败')
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.dataObj.token = data.token
      }).catch(err => {
        showMessage(err, 'error', '七牛Token获取失败')
      })
    },
    // dialog form methods
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.isEditMode) {
            this.updateLeague()
          } else {
            this.addLeague()
          }
        } else {
          return false
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      getLeagueList(this.listQuery).then(response => {
        const data = response
        // console.log('getLeagueList data', data)
        this.list = data
        this.listLoading = false
      })
      getLeagueListPagination(this.listQuery).then(response => {
        const data = response[0]
        // console.log('getLeagueListPagination data', data)
        this.currentPage = data.pageNum
        this.totalCount = data.count
      })
    },
    getLeagueById(leagueId) {
      getLeague(leagueId).then(response => {
        const data = response[0]
        this.dialogForm = data
      })
    },
    addLeague() {
      addLeague(this.dialogForm).then(response => {
        const data = response
        // console.log('addLeague', data)
        if(data) {
          this.dialogVisible = false
          showMessage('success', '创建成功')
          this.getList()
        }
      })
    },
    updateLeague() {
      updateLeague(this.dialogForm).then(response => {
        const data = response
        // console.log('updateLeague', data)
        if(data) {
          this.dialogVisible = false
          showMessage('success', '更新成功')
          this.getList()
        }
      })
    },
    deleteLeague(id) {
      deleteLeague(id).then(response => {
        const data = response
        if(data) {
          showMessage('success', '删除成功')
          this.getList()
        }
      })
    },
  },
  filters: {
    ImageFormats(img) {
      return ImageFormat.squareImageView(img, 256)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.league-container {
  margin: 30px 15px;
  .action-header {
    padding: 0 10px 10px 10px;
  }
  .el-table {
    th {
      div {
        line-height: 20px;
      }
      .el-select {
        padding-left: 0;
        padding-right: 0;
        .el-input {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }

  .table-footer {
    text-align: center;
    margin-top: 30px;
  }

  /* avatar upload start */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 20px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
  }
  .avatar {
    width: 128px;
    height: 128px;
    display: block;
  }
  /* avatar upload end */

  /* dialog modal start */
  .el-dialog {
    width: 540px;
    .el-form-item {
      .el-input {
        width: 300px;
      }
    }
  }
  /* dialog modal end*/
}
</style>
